export default __webpack_public_path__ + "static/media/zickle-miner.00021dcf.png";